import { createFileRoute } from "@tanstack/react-router";
import { AboutStory, AboutValues, AboutFounder } from "#/components/pages/about";
import { FinalCTA } from "#/components/pages/home";
import { PageHeader } from "#/components/shared/PageHeader";
import { BUSINESS } from "#/lib/constants";
import { HEADER } from "#/lib/images";
import { getAboutPageSchema } from "#/lib/seo";

const TITLE = "About Us | Blue Rock Concrete, Wilmington DE";
const DESCRIPTION =
  "Family owned concrete contractor in Wilmington, Delaware. Founded by Nick Coppola, sister company to Blue Rock Tree Care. Licensed, bonded and insured across DE, PA and MD.";

export const Route = createFileRoute("/about")({
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESCRIPTION },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESCRIPTION },
      { property: "og:url", content: "https://bluerockconcreteco.com/about" },
    ],
    links: [{ rel: "canonical", href: "https://bluerockconcreteco.com/about" }],
    scripts: [
      { type: "application/ld+json", children: JSON.stringify(getAboutPageSchema()) },
    ],
  }),
  component: AboutPage,
});

function AboutPage() {
  return (
    <main>
      <PageHeader
        eyebrow="The People Behind the Pour"
        title="Family owned. Poured to last."
        intro={`Since ${BUSINESS.founded} we have been pouring the driveways, patios and walkways that Delaware, Pennsylvania and Maryland homeowners use every single day. Still local, still family owned, and the owner still walks the property before we quote it.`}
        image={HEADER.reviews.src}
        imageMobile={HEADER.reviews.mobile}
        imageAlt={HEADER.reviews.alt}
      />

      <AboutStory />
      <AboutValues />
      <AboutFounder />
      <FinalCTA />
    </main>
  );
}
